export default __webpack_public_path__ + "static/media/D3.4593c780.mp3";